<template>
    <div class="page-container building-container" :class="{rotated:animationStarted}">
        <div class="wtw-container small text-center">
            <logo class="logo-large"></logo>
<!--             <div class="radial-progress">
                <div class="circle">
                    <div class="mask full">
                        <div class="fill"></div>
                    </div>
                    <div class="mask half">
                        <div class="fill"></div>
                        <div class="fill fix"></div>
                    </div>
                    <img class="big-w" :src="imageUrl('big-w@2x.png')"/>
                </div>
                <div class="inset"></div>
            </div>  -->
            <div class="account-complete-video">
                <img :src="imageUrl('account-complete-animation.gif')">
            </div>
<!--             <video class="account-complete-video" muted playsinline webkit-playsinline autoplay>
                <source :src="imageUrl('account-complete-animation.mov')" type="video/mp4">
            </video> -->
            <div class="wtw-container building-text-container">
                <transition-group name="fade-slow-up" mode="out-in">
                    <div class="building-text" v-if="animationStarted && !animationComplete" key="1">
                        Thank You. We are now building a custom shopping experience just for you!
                    </div>
                    <div class="building-text" v-if="animationComplete" key="2">
                        Your Account is Ready! Loading your account now....
                    </div>
                </transition-group>
            </div>
        </div>
    </div>
</template>

<script>

    import Logo from '../header/logo.vue';
    import Mixins from '../../mixins/mixins';

    export default{
        data(){
            return {
                animationStarted: false,
                animationComplete: false,
            }
        },
        components: {
            Logo
        },
        created(){
            this.$store.commit('onboarding/resetState');
        },
        mixins: [Mixins],
        mounted(){
            this.$helpers.trackEvent("complete_onboarding", {});
            setTimeout(() => {
                this.animationStarted = true;
            }, 100);

            setTimeout(() => {
                this.animationComplete = true;
            }, 5000);


            setTimeout(() => {
                this.$router.push({path:'/'});
            }, 7300);
        }

    }

</script>